import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Tchek } from '../model/tchek';
import { Client } from '../model/client';
import { Vehicle } from '../model/vehicle';
import { Terminal } from '../model/terminal';
import { Folder } from '../model/folder';
import { Company } from '../model/company';
import { Device } from '../model/device';
import { Roi } from '../model/roi';
import { TchekUser } from '../model/user';
import { Activity } from '../model/activity';
import { Categorie } from '../model/categorie';
import { CheckList } from '../model/categorie';
import { DefinitionEtat } from '../model/categorie';
import { Etat } from '../model/etat';
import { Contract } from '../model/hitech';

// const Parse = require('parse');
import 'parse';
const parse: typeof Parse = require('parse');
import { Detail, FavoritePictureFilters } from '../model/detail';
import { Camera } from '../model/camera';
import { Settings } from '../model/settings.model';
import { ParametersService } from './parameters.service';

@Injectable()
export class ParseFunctionService {
  constructor(
    private readonly _parametersService: ParametersService
  ) { }

  getCompany(theCompany: Parse.Object, settings?: boolean): Company {
    const newCompany: Company = new Company();
    newCompany.id = theCompany.id;
    newCompany.identifier = theCompany.get('identifier');
    newCompany.address = theCompany.get('address');
    newCompany.logo = theCompany.get('logo')
      ? theCompany.get('logo')._url
      : 'undefined';
    newCompany.name = theCompany.get('name');
    newCompany.date = theCompany.createdAt;
    if (settings)
      newCompany.settings = this._parametersService.settingsOf(theCompany.get('settingsPtr'));
    return newCompany;
  }

  getVehicle(theVehicle: Parse.Object): any {
    const newVehicle: any = new Vehicle();
    if (typeof theVehicle === 'undefined') {
      newVehicle.immat = 'undefined';
      newVehicle.color = 'undefined';
      newVehicle.brand = 'undefined';
      newVehicle.model = 'undefined';
      // newVehicle.circulationDate = "undefined"
    } else {
      newVehicle.id = theVehicle.id;
      newVehicle.webObjectId = theVehicle.get('webObjectId');
      newVehicle.immat = theVehicle.get('immat');
      newVehicle.color = theVehicle.get('color');
      newVehicle.brand = theVehicle.get('brand');
      newVehicle.model = theVehicle.get('model');
      newVehicle.circulationDate = theVehicle.get('circulationDate');
      newVehicle.categorie = theVehicle.get('categorie');
      newVehicle.cle = theVehicle.get('cle');
      newVehicle.capaciteReservoir = theVehicle.get('capaciteReservoir');
      newVehicle.jauge = theVehicle.get('jauge');
      newVehicle.company = theVehicle.get('companyPtr')
        ? this.getCompany(theVehicle.get('companyPtr'))
        : null;
    }
    return newVehicle;
  }

  getUser(TheUser: Parse.Object): TchekUser {
    const newUser: TchekUser = new TchekUser();
    newUser.id = TheUser.id;
    newUser.firstname = TheUser.get('firstname');
    newUser.lastname = TheUser.get('lastname');
    newUser.email = TheUser.get('email');

    newUser.companyPtr = TheUser.get("companyPtr")
      ? TheUser.get("companyPtr")
      : null;
    newUser.devicePtr = TheUser.get('devicePtr')
      ? TheUser.get('devicePtr').id
      : null;

    if (TheUser.get('devicePtr')) {
      newUser.devicePtrIPMachine = TheUser.get('devicePtr').get('ipMachine')
        ? TheUser.get('devicePtr').get('ipMachine')
        : null;

    } else {
      newUser.devicePtrIPMachine = null;
    }

    newUser.isAdmin = TheUser.get('isAdmin');
    newUser.isSuperAdmin = TheUser.get('isSuperAdmin');
    newUser.canDetection = TheUser.get('canDetection');
    newUser.canEdit = TheUser.get('canEdit');
    newUser.canAnnotate = TheUser.get('canAnnotate');
    newUser.canShare = TheUser.get('canShare');
    newUser.canState = TheUser.get('canState');
    newUser.canFilter = TheUser.get('canFilter');
    return newUser;
  }

  getDevice(TheDevice: Parse.Object): Device {
    if (!TheDevice) return null;
    const newDevice: Device = new Device();
    newDevice.id = TheDevice.id;
    newDevice.address = TheDevice.get('address');
    newDevice.serialNumber = TheDevice.get('serialNumber');
    newDevice.webObjectId = TheDevice.get('webObjectId');
    newDevice.ipMachine = TheDevice.get('ipMachine');

    return newDevice;
  }

  getTchek(theTchek: Parse.Object): Tchek {
    const newTchek: Tchek = new Tchek();
    newTchek.id = theTchek.id;
    newTchek.date = theTchek.get('tchekCreatedAt');
    newTchek.path = theTchek.get('path');
    newTchek.number = theTchek.get('number');
    newTchek.isSigned = theTchek.get('isSigned');
    newTchek.isUploaded = theTchek.get('isUploaded');
    newTchek.isDeletedFromLocal = theTchek.get('isDeletedFromLocal');
    newTchek.providerSig = theTchek.get('providerSignature');
    newTchek.customerSig = theTchek.get('customerSignature');
    newTchek.webObjectId = theTchek.get('webObjectId');
    newTchek.dateSignature = theTchek.get('dateSignature');
    newTchek.vehicle = this.getVehicle(theTchek.get('vehiclePtr'));
    newTchek.devicePtr = this.getDevice(theTchek.get('devicePtr'));
    newTchek.uploadHDPictures = false
    if (theTchek.get('uploadHDPictures') == true) {
      newTchek.uploadHDPictures = true
    }
    newTchek.toDownload = theTchek.get('toDownload');
    newTchek.detectionFinished = false
    if (theTchek.get('detectionFinished') == true) {
      newTchek.detectionFinished = true
    }
    newTchek.toUpload = theTchek.get('toUpload');
    // newTchek.details = this.getDetail(theTchek.get("details"));
    newTchek.objectDetected = theTchek.get('objectDetected');
    newTchek.probabilityVehicle = theTchek.get('probabilityVehicle');
    return newTchek;
  }

  getTcheks(theTchek: Parse.Object): Tchek {
    const newTchek: Tchek = new Tchek();
    newTchek.id = theTchek.id;
    newTchek.date = theTchek.get('tchekCreatedAt');
    newTchek.path = theTchek.get('path');
    newTchek.number = theTchek.get('number');
    newTchek.isSigned = theTchek.get('isSigned');
    newTchek.providerSig = theTchek.get('providerSignature');
    newTchek.customerSig = theTchek.get('customerSignature');
    newTchek.dateSignature = theTchek.get('dateSignature');
    newTchek.vehicle = this.getVehicle(theTchek.get('vehiclePtr'));
    newTchek.devicePtr = this.getDevice(theTchek.get('devicePtr'));
    return newTchek;
  }

  getClient(theClient: Parse.Object): Client {
    const newClient: Client = new Client();
    newClient.id = theClient.id;
    newClient.lastname = theClient.get('lastname');
    newClient.firstname = theClient.get('firstname');
    newClient.room = theClient.get('room');

    return newClient;
  }

  getActivity(theActivity: Parse.Object): Activity {
    const newActivity: Activity = new Activity();
    newActivity.id = theActivity.id;
    newActivity.type = theActivity.get('type');
    newActivity.clientPtr = theActivity.get('clientPtr')
      ? this.getClient(theActivity.get('clientPtr'))
      : theActivity.get('clientPtr');
    newActivity.tchekPtr = this.getTcheks(theActivity.get('tchekPtr'));
    newActivity.userPtr = this.getUser(theActivity.get('userPtr'));
    newActivity.date = theActivity.createdAt;

    return newActivity;
  }

  getFolder(theFolder: Parse.Object): Folder {
    const newFolder: Folder = new Folder();
    if (theFolder === undefined)
      return newFolder
    newFolder.id = theFolder.id;
    newFolder.totalPictures = theFolder.get('totalPictures');
    newFolder.name = theFolder.get('name');
    newFolder.descCam = theFolder.get('descCam');
    newFolder.tchek = this.getTchek(theFolder.get('tchekPtr'));
    newFolder.tchek.vehicle = this.getVehicle(
      theFolder.get('tchekPtr').get('vehiclePtr')
    );
    newFolder.company = this.getCompany(
      theFolder
        .get('tchekPtr')
        .get('devicePtr')
        .get('companyPtr')
    );
    return newFolder;
  }
  getCamera(theCamera: Parse.Object): Camera {
    const newCam: Camera = new Camera();
    newCam.id = theCamera.id;
    newCam.name = theCamera.get('name');
    newCam.orderCam = theCamera.get('orderCam');
    newCam.descCam = theCamera.get('descCam');
    return newCam;
  }

  getDetail(theDetail: Parse.Object): Detail {
    const newDetail: Detail = new Detail();
    newDetail.id = theDetail.id;
    newDetail.pictureNumber = theDetail.get('pictureNumber');
    newDetail.cameraName = theDetail.get('cameraName');
    newDetail.isSelected = theDetail.get('isSelected');
    const filters = theDetail.get('filters');
    if (filters !== undefined)
      newDetail.filters = filters as FavoritePictureFilters;
    newDetail.tchek = this.getTcheks(theDetail.get('tchekPtr'));
    newDetail.comparePtr = theDetail.get('comparePtr');
    return newDetail;
  }

  getCheckList(theCheckList: Parse.Object): CheckList {
    const newCheckList: CheckList = new CheckList();
    newCheckList.id = theCheckList.id;
    newCheckList.categorieCle = theCheckList.get('categorieCle');
    newCheckList.libelle = theCheckList.get('libelle');
    newCheckList.code = theCheckList.get('code');
    newCheckList.type = theCheckList.get('type');
    newCheckList.cle = theCheckList.get('cle');
    return newCheckList;
  }

  getDefinitionEtat(theDefinitionEtat: Parse.Object): DefinitionEtat {
    const newDefinitionEtat: DefinitionEtat = new DefinitionEtat();
    newDefinitionEtat.id = theDefinitionEtat.id;
    newDefinitionEtat.categorieCle = theDefinitionEtat.get('categorieCle');
    newDefinitionEtat.section = theDefinitionEtat.get('section');
    newDefinitionEtat.statut = theDefinitionEtat.get('statut');
    newDefinitionEtat.statutCle = theDefinitionEtat.get('statutCle');
    newDefinitionEtat.sectionCle = theDefinitionEtat.get('sectionCle');
    return newDefinitionEtat;
  }

  getEtat(theEtat: Parse.Object): Etat {
    const newEtat: Etat = new Etat();
    if (theEtat) {
      newEtat.id = theEtat.id;
      newEtat.materielCle = theEtat.get('materielCle');
      newEtat.materielNature = theEtat.get('materielNature');
      newEtat.document = theEtat.get('document');
      newEtat.type = theEtat.get('type');
      newEtat.typeDocument = theEtat.get('typeDocument');
      newEtat.niveauCarburant = theEtat.get('niveauCarburant');
      newEtat.kilometrage = theEtat.get('kilometrage');
      newEtat.note = theEtat.get('note');
      newEtat.elementEtatInterieur = theEtat.get('elementsEtatInterieur');
      newEtat.elementEtatExterieur = theEtat.get('elementsEtatExterieur');
      newEtat.reponsesCheckList = theEtat.get('reponsesCheckList');
    }
    return newEtat;
  }

  getContract(theContract: Parse.Object): Contract {
    const newContract: Contract = new Contract();
    newContract.id = theContract.id;
    newContract.materielCle = theContract.get('materielCle');
    newContract.niveauCarbDepart = theContract.get('niveauCarbDepart');
    newContract.niveauCarbRetour = theContract.get('niveauCarbRetour');
    newContract.kmRetour = theContract.get('kmRetour');
    newContract.kmDepart = theContract.get('kmDepart');
    newContract.numeroContrat = theContract.get('numeroContrat');
    newContract.email = theContract.get('email');
    newContract.intituleClient = theContract.get('intituleClient');
    newContract.retour = theContract.get('retour');
    newContract.depart = theContract.get('depart');
    newContract.cleDocuemnt = theContract.get('cleDocument');
    newContract.conducteur = theContract.get('conducteur');
    return newContract;
  }

  getRois(theRoi: Parse.Object): Roi {
    const newRoi: Roi = new Roi();
    newRoi.id = theRoi.id;
    newRoi.date = theRoi.createdAt;
    newRoi.centerX = theRoi.get('centerX');
    newRoi.centerY = theRoi.get('centerY');
    newRoi.width = theRoi.get('width');
    newRoi.height = theRoi.get('height');
    newRoi.isAuto = theRoi.get('isAuto');
    newRoi.comment = theRoi.get('comment');
    newRoi.radius = theRoi.get('radius');
    newRoi.type = theRoi.get('type');
    newRoi.picture = theRoi.get('picture');
    newRoi.tchek = this.getTchek(theRoi.get('tchekPtr'));
    newRoi.folder = theRoi.get('folder');
    return newRoi;
  }
  /*getUser(theUser:parse.Object):User{
    var newUser: User = new User();
    newUser.name = theUser.get("name");
    newUser.avatar = theUser.get("avatar");
    return newUser;
  }*/
}



// WEBPACK FOOTER //
// ./src/app/service/parsefunction.service.ts